import React, { useState, useRef, useEffect } from "react";
import { Row, Col } from "react-bootstrap";
import { IconPPT, IconDownload, IconReportIssue, MaximizeIcon } from "../../../icons/Icons";
import { Link, useLocation, useHistory } from "react-router-dom";
import { pageType } from "../../../helper/pageType";
import DocViewer, { DocViewerRenderers } from "react-doc-viewer";
import Header from "./Header";
import {
  generatePresignedUrl,
  bulkGeneratePresignedUrl,
} from "../../../api/common-store-api";
import { useSelector } from "react-redux";
import { getGUID } from "../../../common";

const Ppt = ({ actionReport, contentUrl, slideData, setContent, setIsFullScreenPpt, isFullScreenPpt }) => {
  const location = useLocation();
  let history = useHistory();
  const [contentUrlData, setContentUrlData] = useState(null);
  const userRole = useSelector(
    (state) => state.user.currentUser?.roles[0].name
  );

  const arrayDownloadableFiles = slideData?.downloadableFile;
  const [downloadableFileURLs, setDownloadableFileURLs] = useState([]);

  const [current, setCurrent] = useState(0);
  const length = ImageData.length;

  const [show, setShow] = useState(false);
  const target = useRef(null);

  const getPreviewUrl = async () => {
    const getGuid = getGUID(contentUrl);
    let previewUrl = await generatePresignedUrl(getGuid);
    if (previewUrl?.data) {
      setContentUrlData(previewUrl.data);
    }
  };

  useEffect(() => {
    getPreviewUrl();
    getBulkGeneratePresignedUrl();
  }, []);

  const linkToPPTFile = contentUrlData;
  // /   "https://scholar.harvard.edu/files/torman_personal/files/samplepptx.pptx";

  const pptFile = [
    { uri: contentUrlData, fileType: contentUrl.split(".").pop() },
  ];

  const getBulkGeneratePresignedUrl = async () => {
    if (
      arrayDownloadableFiles !== undefined &&
      arrayDownloadableFiles !== null &&
      arrayDownloadableFiles.length > 0
    ) {
      let responseURLsDownloadable = await bulkGeneratePresignedUrl(
        arrayDownloadableFiles.map((value) => value.filePath)
      );
      if (responseURLsDownloadable?.data) {
        setDownloadableFileURLs(responseURLsDownloadable.data);
      }
    }
  };
 const handleIsFullScreen = () => {
    setIsFullScreenPpt(true);
  };
  const handleCloseFullScreen = () => {
    setIsFullScreenPpt(false);
  };
  return (
    <div className="pages">
      {/* <Header nextSlide={nextSlide} prevSlide={prevSlide}/>
            <div className='position-relative' style={{ top: '-1px' }}>
                <div className="progress tableProgress bg-base-100 " style={{ height: '2px' }} ref={target} onMouseEnter={() => setShow(!show)}>
                    <div className="progress-bar bg-primary-200" role="progressbar" style={{ width: '21%' }}></div>
                </div>
            </div> */}
      <div className="pageOuter pb-0">
        <Row className="g-0 h-100">
          <Col className="col-lg-12">
            <div className="videoPreview pptPreview position-relative">
              <button
                className="position-absolute cursor-pointer"
                style={{ right: "16px", top: "16px", zIndex: 1 }}
                onClick={
                  isFullScreenPpt ? handleCloseFullScreen : handleIsFullScreen
                }
              >
                {isFullScreenPpt ? (
                  <svg
                    width="31"
                    height="31"
                    viewBox="0 0 31 31"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect
                      opacity="0.5"
                      x="0.0908203"
                      y="0.0909424"
                      width="30"
                      height="30"
                      rx="5.625"
                      fill="#232323"
                    />
                    <path
                      d="M8.925 22.125L7.875 21.075L10.2 18.75H8.25V17.25H12.75V21.75H11.25V19.8L8.925 22.125ZM21.075 22.125L18.75 19.8V21.75H17.25V17.25H21.75V18.75H19.8L22.125 21.075L21.075 22.125ZM8.25 12.75V11.25H10.2L7.875 8.925L8.925 7.875L11.25 10.2V8.25H12.75V12.75H8.25ZM17.25 12.75V8.25H18.75V10.2L21.075 7.875L22.125 8.925L19.8 11.25H21.75V12.75H17.25ZM15 16.5C14.5875 16.5 14.2344 16.3531 13.9406 16.0594C13.6469 15.7656 13.5 15.4125 13.5 15C13.5 14.5875 13.6469 14.2344 13.9406 13.9406C14.2344 13.6469 14.5875 13.5 15 13.5C15.4125 13.5 15.7656 13.6469 16.0594 13.9406C16.3531 14.2344 16.5 14.5875 16.5 15C16.5 15.4125 16.3531 15.7656 16.0594 16.0594C15.7656 16.3531 15.4125 16.5 15 16.5Z"
                      fill="white"
                    />
                  </svg>
                ) : (
                  <MaximizeIcon />
                )}
              </button>
              <DocViewer
                pluginRenderers={DocViewerRenderers}
                documents={pptFile}
                config={{
                  header: {
                    disableHeader: true,
                    disableFileName: true,
                    retainURLParams: false,
                  },
                }}
                style={{ height: 500 }}
              />
              {/* <div className="mt-3">
                  <i className="text-gray-200 h6">
                    Use arrow keys to move through the presentation
                  </i>
                </div> */}
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default Ppt;
